<script>
import firebase from 'firebase';
import store from '../store';
import pdf from 'vue-pdf';

export default {
    name: 'lesson',
    components: {
        pdf
    },
    data() {
        return {
            numPages: null,
            pages: null,
            content: ``, //is now lessonContent
            currentLessonID: '',
            lessonContentURL: '',
            title: '',
            sticky: false,
            bannerOffset: 0,
            authenticated: null,
            triggered: false,
            claims: {},
            userRef: {
                progress: {
                    advisroy: null,
                    managed_services: null,
                    operations: null
                },
                completed: []
            }
        }
    },
    created() {
        console.log('lesson component created');
        this.fetchQuestions();
        store.commit('lessonPage');
        this.bindData();
        //console.clear();
        console.log('BEGIN CLOCK FOR LESSON');
        console.log('BEGIN CLOCK FOR LESSON CONTEXT');
    },
    mounted() {
        console.clear();
        console.log('mounted...');
        this.fetchText(); //async call is happening
    },
    computed: {
        context() {
            return this.$route.params.current;
        },
        mockText() {
            return (
                `
                    <h1 style="color:blue">Mock text!</h1>
                `
            );
        },
        dark() {
            return store.state.dark;
        },
    },
    methods: {
        getPages(e) {
            console.log("Pages: " + e);
            // this.numPages = e;
        },

        bindData() {

            //variables for 

            console.log('binding data..........');
            var self = this;
            var fireRef = firebase.firestore().collection('users');
            fireRef.doc(self.claims.uid).get().then((doc) => {
                console.log('exists?: ', doc.exists);

                console.log('doc exists');
                console.log(doc.data());
                self.userRef.progress.advisory = doc.data().progress.advisory;
                self.userRef.progress.managed_services = doc.data().progress.managed_services;
                self.userRef.progress.operations = doc.data().progress.operations;
                self.userRef.completed = doc.data().completed;

                try {
                    self.userRef.completed = [...doc.data().completed];
                }
                catch {
                    console.log('no lessons completed yet');
                }
                
            });

            //console.log('data successfully binded.');
        },
        fetchQuestions() {
            var self = this;
            firebase.firestore().collection('quizzes').where('lessonID', '==', this.context).get().then((docs) => {
                console.log();
                console.log("CURRENT LESSON ID: ", self.currentLessonID);
                console.log();
                docs.forEach((doc) => {
                    //console.log(doc.data().serviceLine);
                    self.title = doc.data().serviceLine;
                    self.currentLessonID = doc.data().lessonID;
                });
            });
        },
        //fetchQuestions used in Quiz component
        fetchText() {
            var self = this;
            /*firebase.firestore().collection("lessons").where("lessonID","==",this.context).get().then((docs) => {
                docs.forEach((doc) => {
                    self.content = doc.data().content;
                });
            });*/

            //create a storage ref and download file
            var lessonRef = firebase.storage().ref("PDFs/" + (parseInt(this.context) < 10 ? "0" + parseInt(this.context) : parseInt(this.context)) + ".pdf");

            lessonRef.getDownloadURL().then((url) => {
                console.log();
                console.log("grabbing download url", url);
                console.log("current lesson ID", self.currentLessonID);
                console.log();
                self.lessonContentURL = pdf.createLoadingTask(url);
                self.lessonContentURL.promise.then(pdf => {
                    console.log("PDF: " + pdf.numPages);
                    this.numPages = pdf.numPages;
                }) 
            }).catch((error) => {
                switch(error.code) {
                    case 'storage/object-not-found':
                        //file doesn't exist
                        break;
                    case 'storage/unauthorized':
                        //storage/unauthorized
                        break;
                    case 'storage/canceled':
                        //storage/canceled
                        break;
                    case 'storage/unknown':
                        //unknown error
                        break;
                }
            });
        },
        handleScroll() {
            //console.log(scrollY);
            this.bannerOffset = scrollY;
            if(window.scrollY > 60) {
                //console.log('trigger sticky');
                this.sticky = true;
                //store.commit('navTrigger');
            }
            else {
                //store.commit('navTrigger');
                this.sticky = false;
            }

            if(window.scrollY >= 100) {
                this.triggered = true;
            }
            else {
                this.triggered = false;
            }
        },
        alreadyComplete() {
            if(this.userRef.completed.includes(this.context)) {
                console.log('LESSON ALREADY COMPLETED');
            }
        }
    }
}
</script>

<template>
<transition name="fade" mode="out-in">
    <div class="lesson-container" :class="(dark ? 'dark' : '' )">
        <div class="sky" v-scroll="handleScroll" :class="(sticky ? 'sticky' : '')"></div>
        <div class="banner">
            <!--h1>{{ title }}</h1-->
        </div>
        <!--div class="lesson-text-container" v-html="content"></div-->
        <!--iframe class="lesson-embedded-container" :src="lessonContentURL" /-->
        <div class="pdf-container">
            <pdf
			v-for="(i, index) in numPages"
			:key="index"
			:page="i"
            :src="lessonContentURL">
            </pdf>
        </div>
        <div v-if="!numPages" class="empty-lesson"><span>Document not yet available...</span></div>
        
        <router-link :to="'/quiz/' + $route.params.current"><div class="quiz-button"><span>Continue to Quiz 🠚</span></div></router-link>
    </div>
</transition>
</template>

<style lang="scss">
@import '../assets/global-styles/variables';

.pdf-container {
    opacity: 0;
    width: 60%;
    // height: 100%;
    margin-left: auto;
    margin-right: auto;
    animation: flyup 1s ease forwards 500ms;
}

.empty-lesson {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 18px;
    height: 100vh;
    width: 100%;
    top: 0px;
    z-index: -1;
    opacity: 0.5;
    
    span {
        opacity: 0;
        animation: flyin 1s ease forwards 3s;
    }
}

.lesson-embedded-container {
    width: 100% !important;
    height: calc(100vh - #{$navHeight}) !important;
    border: none !important;
    display: block;
    //animation: decompress 2s ease forwards;
}

.gone {
    opacity: 0;
    transform: scale(0.4);
}

.here {
    opacity: 1;
    transform: scale(1);
}

.sticky {
    opacity: 1 !important;
}

h1 {
    opacity: 0;
    margin-top: 80px;
    font-size: 52px;
    font-weight: normal;
    animation: flyin 1s ease forwards 1.5s;
    transition: 300ms;
}

body {
    overflow: auto;
}

.banner {
    opacity: 0;
    position: relative;
    background: white;
    height: $navHeight !important;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;
    //padding-left: $gap;
    color: white;
    //background-image: url('../assets/lic.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
    transition: 0s;
    //animation: grow-v 2s ease forwards 0.5s;
}

.lesson-container {
    font-family: Nunito, roboto, sans-serif;
    //padding-bottom: 150px;
    overflow: hidden !important;
}

.dark {

    h1 {
        color: white;
    }

    .sky {
        background: $colorDarkMid;
        box-shadow: 0px 12px 42px 42px $colorDarkMid;
    }

    .quiz-button {
        background: white !important;
        color: black !important;
        border-color: $colorDarkMid;
        //box-shadow: $softerShadow;

        &:hover {
            background: transparent;
            border: 2px solid white;
            color: white !important;
        }
    }

    .banner {
    }
}

.sky {
    background: white;
    width: 100%;
    height: 60px;
    z-index: 1;
    position: fixed;
    top:0px;
    margin: 0px;
    padding: 0px;
    padding-bottom: 38px;
    opacity: 0;
    box-shadow: 0px 12px 42px 42px white;
    border-radius: 0px 0px ($rad *2) ($rad * 2);
}

.lesson-text-container {
    //background: red;
    opacity: 0;
    width: 50% !important;
    margin-left: auto;
    margin-right: auto;
    padding-top: 80px;
    padding-bottom: 80px;
    font-size: 18px;
    line-height: 2;
    //animation: flyup 1s forwards ease 2s;
}

a {
    text-decoration: none !important;
}

.quiz-button {
    position: fixed;
    left: $gap;
    bottom: 434px;
    margin: auto;
    color: white;
    background:black;
    width: 230px;
    height: 60px;
    border: 2px solid black;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 90px;
    cursor: pointer;
    opacity: 0;
    animation: flyup 1s forwards ease 1s;
    margin-bottom: -400px;
    //box-shadow: $softerShadow;

    span {
        padding: 12px 18px 12px 18px;
        font-size: 18px;
        font-weight: bold;
        transition: 0ms;
    }

    &:hover {
        background: transparent;
        border: 2px solid black;
        color: black !important;
    }
}
</style>